import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bpt/topedgedev/db-homeschool/src/app/calendar/pageClient.js");
